(ns client-portal.client.user-management.roles.data
  (:require [client-portal.client.user-management.data :as um.d]
            [clojure.string :as s]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def form-path (conj um.d/root-path :role-form))
(def save-path (conj um.d/root-path :role-save))
(def permission-form-path (conj um.d/root-path :permission-form))
(def permission-request-path (conj um.d/root-path :permission-request))

(re/reg-sub :user-management/application-filter- #(get-in % (conj um.d/filters-path :application-id)))

(re/reg-event-db
  :user-management/edit-role re/middleware
  (fn [db [role application-id]]
    (re/dispatch [:dialog/show [:user-management/role-dialog]])
    (assoc-in db form-path (merge {:application-id application-id
                                   :permission-ids []
                                   :internal false
                                   :original-label (:label role)}
                                  (select-keys role [:id :application-id :label :permission-ids :internal])))))

(re/reg-sub :user-management/role-form- #(get-in % form-path))

(re/auth0-http-request
  :user-management/save-role
  save-path
  (fn [db _]
    (let [{:keys [id application-id label permission-ids internal]} (get-in db form-path)]
      (when-not (s/blank? label)
        {:method :post
         :url "/api/user-management/roles"
         :json-params (util/->camelCaseKeywords (cond-> {:application-id application-id
                                                         :label (s/trim label)
                                                         :permission-ids (vec permission-ids)
                                                         :internal (boolean internal)}
                                                        id (assoc :id id)))})))
  :on-success (fn [db [{:keys [body]}] _]
                (re/dispatch [:dialog/hide])
                (re/dispatch [:toasts/add-info {:msg (if (get-in db (conj form-path :id))
                                                       "Role saved"
                                                       (str "Created " (:label body)))
                                                :duration 3000}])
                (re/dispatch [:user-management/load-roles :reload])
                db)
  :on-fail (fn [db {:keys [body]} _]
             (re/dispatch [:toasts/add-error {:msg (or (:message body) "Couldn't save the role. Try again.")
                                              :duration 6000}])
             db))

(re/reg-sub :user-management/saving-role?- #(get-in % (conj save-path :request-active?)))

(re/auth0-http-request
  :user-management/add-permission
  permission-request-path
  (fn [db _]
    (let [scope (some-> (get-in db (conj permission-form-path :scope)) (s/trim))]
      (when-not (s/blank? scope)
        {:method :post
         :url "/api/user-management/permissions"
         :json-params {:scope scope}})))
  :on-success (fn [db [{:keys [body]}] _]
                (re/dispatch [:toasts/add-info {:msg (str "Added " (:scope body))
                                                :duration 3000}])
                (re/dispatch [:user-management/load-permissions :reload])
                (assoc-in db permission-form-path {}))
  :on-fail (fn [db {:keys [body]} _]
             (re/dispatch [:toasts/add-error {:msg (or (:message body) "Couldn't add the permission. Try again.")
                                              :duration 6000}])
             db))

(re/auth0-http-request
  :user-management/delete-permission
  permission-request-path
  (fn [_ {:keys [id]}]
    {:method :delete
     :url (str "/api/user-management/permissions/" id)})
  :on-success (fn [db _ {:keys [event-args]}]
                (re/dispatch [:dialog/hide])
                (re/dispatch [:toasts/add-info {:msg (str "Deleted " (:scope event-args))
                                                :duration 3000}])
                (re/dispatch [:user-management/load-permissions :reload])
                (re/dispatch [:user-management/load-roles :reload])
                db)
  :on-fail (fn [db {:keys [body]} _]
             (re/dispatch [:toasts/add-error {:msg (or (:message body) "Couldn't delete the permission. Try again.")
                                              :duration 6000}])
             db))

(re/reg-sub :user-management/permission-request-active?- #(get-in % (conj permission-request-path :request-active?)))
